<template>
<div class="col-xs-12">
  <div v-if="!loaded" class="card float-e-margins">
    <div class="card-content no-padding text-center">
      <i class="fa fa-refresh fa-spin fa-5x fa-lg"></i>
      <span class="sr-only">Laden...</span>
      Laden...
    </div>
  </div>
  <div v-else class="card float-e-margins">
    <div class="card-title header">
        <h1 v-if="update">Advertentie aanpassen</h1>
        <h1 v-else>Advertentie plaatsen</h1>
    </div>
    <div class="card-content no-padding">
      <div class="row">
        <div class="col-xs-12">
          <!--start Rubriek-->
          <div class="card float-e-margins">
            <div class="card-title card-header">
              <div class="col-lg-6">
                <h5>
                  1. Kies rubriek
                </h5>
              </div>
            </div>
            <div class="row">
              <div class="card-content no-padding">
                <v-select :value.sync="product.MenuItemId" :options="selectOptions" :search="true">
                </v-select>
              </div>
            </div>
          </div>
          <!--end Rubriek-->
          <!--start Title-->
          <div class="card float-e-margins">
            <div class="card-title card-header">
              <div class="col-lg-6">
                <h5>
                  2. Titel en kenmerken
                </h5>
              </div>
            </div>
            <div class="row">
              <div class="card-content no-padding">
                <div class="form-group">
                  <label for="title">Titel:</label>
                  <input type="text" class="form-control" id="title" v-model="product.Name">
                </div>
              </div>
            </div>
          </div>
          <!--end Title-->
          <!--start Description-->
          <div class="card float-e-margins">
            <div class="card-title card-header">
              <div class="col-lg-6">
                <h5>
                  3. Beschrijving
                </h5>
              </div>
            </div>
            <div class="row">
              <div class="card-content no-padding">
                <div class="form-group col-md-8">
                  <label for="description">Beschrijving:</label>
                  <textarea class="form-control" rows="10" v-model="product.Description" id="description"></textarea>
                </div>
              </div>
            </div>
          </div>
          <!--end Description-->
          <!--start Photos-->
          <div class="card float-e-margins">
            <div class="card-title card-header">
              <div class="col-lg-6">
                <h5>
                  4. Upload Foto's
                </h5>
              </div>
            </div>
            <div class="row">
              <div class="card-content no-padding">
                <div class="form-group">
                  <v-upload :files.sync="product.Photos"></v-upload>
                </div>
              </div>
            </div>
          </div>
          <!--end Photos-->
          <!--start Price-->
          <div class="card float-e-margins">
            <div class="card-title card-header">
              <div class="col-lg-6">
                <h5>
                  5. Prijs
                </h5>
              </div>
            </div>
            <div class="row">
              <div class="card-content no-padding">
                <div class="form-group">
                  <label for="price">Prijs</label>
                  <input type="text" class="form-control" id="price" :disabled="product.PriceOnRequest == 1" :readonly="product.PriceOnRequest == 1" v-model="product.Price | currencyDisplay">
                </div>
                <div class="checkbox">
                  <label>
                    <input type="checkbox" v-model="product.PriceOnRequest"><strong>Prijs Op aanvraag</strong>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <!--end Price-->
          <!-- start submit button -->
          <button v-if="!update" type="button" class="btn btn-primary" @click="handleProduct()">Advertentie Plaatsen</button>
          <button v-else type="button" class="btn btn-primary" @click="updateProduct()">Advertentie Bijwerken</button>
          <!-- end submit button -->
          <!-- after save start -->
          <button v-if="success && !update" type="button" class="btn btn-primary" @click="refresh()">
            Nog een advertentie plaatsen
           </button>
          <vc-alert v-if="success" type="success"
            :timeout="4000">
            {{successMessage}}
          </vc-alert>
          <vc-alert v-if="error" type="danger" :dismissible="false">
             Er is een fout opgetreden!
          </vc-alert>
          <!-- after save end -->
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import store from '../../store'
import select from '../Common/Select'
import upload from '../Common/Upload'
import callbackalert from '../Common/CallbackAlert'
export default {
  route: {
    canReuse: false
  },
  created () {
    this.getRubrieks()
    if (this.$route.params.id !== undefined) {
      this.update = true
      this.getProduct(this.$route.params.id)
    } else {
      this.loaded = true
    }
  },
  ready () {
    document.body.scrollTop = document.documentElement.scrollTop = 0
  },
  components: {
    'v-select': select,
    'v-upload': upload,
    'vc-alert': callbackalert
  },
  data () {
    return {
      store: store,
      rubrieks: [],
      product: {
        MenuItemId: '',
        Name: '',
        Photos: [],
        Description: '',
        Price: '',
        PriceOnRequest: false
      },
      success: false,
      error: false,
      update: false,
      loaded: false
    }
  },
  methods: {
    getRubrieks: function () {
      $.ajax({
        type: 'GET',
        url: store.root + 'api/MenuItems/all',
        dataType: 'json',
        xhrFields: {
          withCredentials: true
        },
        success: function (response) {
          this.rubrieks = response
        }.bind(this)
      })
    },
    handleProduct: function () {
      if (this.product.Price === '') {
        this.product.Price = 0.0
      }
      $.ajax({
        type: 'POST',
        url: store.root + 'api/Products',
        data: this.product,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', 'Bearer ' + store.token)
        },
        xhrFields: {
          withCredentials: true
        }
      }).done(function () {
        this.success = true
        this.error = false
      }.bind(this))
      .fail(function (response) {
        console.log(response)
        this.success = false
        this.error = true
      }.bind(this))
    },
    updateProduct: function () {
      $.ajax({
        type: 'PUT',
        url: store.root + 'api/Products/' + this.product.ProductId,
        data: this.product,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', 'Bearer ' + store.token)
        },
        xhrFields: {
          withCredentials: true
        }
      }).done(function () {
        this.success = true
        this.error = false
      }.bind(this))
      .fail(function (response) {
        console.log(response)
        this.success = false
        this.error = true
      }.bind(this))
    },
    refresh: function () {
      location.reload()
    },
    getProduct: function (id) {
      $.ajax({
        type: 'GET',
        url: store.root + 'api/products/' + id,
        dataType: 'json',
        xhrFields: {
          withCredentials: true
        },
        success: function (response) {
          response.MenuItemId = ['' + response.MenuItemId]
          this.product = response
          this.loaded = true
        }.bind(this)
      })
    }
  },
  computed: {
    selectOptions () {
      return this.rubrieks.map((item) => { return { value: '' + item.MenuItemId, label: item.MenuText } })
    },
    successMessage () {
      if (this.update) {
        return 'Advertentie is succesvol bijgewerkt!'
      } else {
        return 'Advertentie is succesvol toegevoegd!'
      }
    }
  }
}
</script>
<style scoped>
#content input[disabled] {
    color: #DDDD;
    padding: 2px;
    margin: 0 0 0 0;
    background-image: none;
}
</style>


// WEBPACK FOOTER //
// addProduct.vue?9c36334a